import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDataService } from '../../../../core/services/modal-data.service';
import { ModalService } from '../../../../core/services/modal.service';

export interface HealthConditionCommentModalData {
  label: string;
  type: 'comorbidity' | 'precedent';
  code: string;
  passportNumber: string;
}

@Component({
  selector: 'app-health-condition-comment-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './health-condition-comment-modal.component.html',
})
export class HealthConditionCommentModalComponent implements OnInit {
  label = '';
  type: 'comorbidity' | 'precedent' = 'comorbidity';
  code = '';
  passportNumber = '';
  comment = '';

  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    const data = ModalDataService.getData() as HealthConditionCommentModalData | undefined;
    if (data) {
      this.label = data.label ?? '';
      this.type = data.type ?? 'comorbidity';
      this.code = data.code ?? '';
      this.passportNumber = data.passportNumber ?? '';
    }
  }

  validate(): void {
    this.modalService.emitEvent({
      type: 'healthConditionCommentValidated',
      data: {
        comment: this.comment.trim(),
        type: this.type,
        code: this.code,
        label: this.label,
        passportNumber: this.passportNumber,
      },
    });
    this.modalService.closeAll();
  }

  cancel(): void {
    this.modalService.closeAll();
  }
}
